/**
 * The text side of a manifest's `project:` block (card 2.2), pure — no
 * stores, so repoIdentity.js and the YAML loader can use it. The rest is in
 * projectManifest.js.
 */
const str = (v) => (typeof v === 'string' && v.trim() ? v.trim() : null);

/** `{ id, name, color? }` from a parsed manifest's `project`, or null when it is not one. */
export function projectFromManifest(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const id = str(raw.id);
  const name = str(raw.name);
  if (!id || !name) return null;
  const color = str(raw.color);
  return color ? { id, name, color } : { id, name };
}

// A top-level `project:` key and its indented lines.
const BLOCK = /^project:[^\S\r\n]*\r?\n(?:[ \t]+\S[^\r\n]*(?:\r?\n|$))+/m;

/**
 * `generated` (this device's manifest) keeping `existing`'s project block when
 * this device writes none. The block goes where the sorted dump would put it
 * (before the first top-level key after `project`), byte for byte.
 */
export function keepProjectBlock(existing, generated) {
  if (typeof existing !== 'string' || typeof generated !== 'string') return generated;
  if (/^project:/m.test(generated)) return generated;
  const kept = existing.match(BLOCK);
  if (!kept) return generated;
  const block = kept[0].replace(/\r\n/g, '\n').replace(/\n?$/, '\n');
  const lines = generated.split('\n');
  const at = lines.findIndex((l) => /^[A-Za-z_][\w-]*:/.test(l) && l.split(':')[0] > 'project');
  if (at === -1) return `${generated.replace(/\n?$/, '\n')}${block}`;
  return [...lines.slice(0, at), block.replace(/\n$/, ''), ...lines.slice(at)].join('\n');
}

